/**
 * @generated SignedSource<<b14820bb24b6fb8d7360ce89e67a6bd4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetPrimaryAccountMutation$variables = {
  aaid: string;
};
export type SetPrimaryAccountMutation$data = {
  readonly unified: {
    readonly account: {
      readonly setPrimaryAccount: {
        readonly errors: ReadonlyArray<{
          readonly code: string | null;
          readonly extensions: {
            readonly errorType: string | null;
            readonly statusCode: number | null;
          } | null;
          readonly message: string | null;
        }> | null;
        readonly message: string | null;
        readonly success: boolean;
      } | null;
    } | null;
  } | null;
};
export type SetPrimaryAccountMutation = {
  response: SetPrimaryAccountMutation$data;
  variables: SetPrimaryAccountMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aaid"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UnifiedMutation",
    "kind": "LinkedField",
    "name": "unified",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedAccountMutation",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "aaid",
                "variableName": "aaid"
              }
            ],
            "concreteType": "UnifiedLinkingStatusPayload",
            "kind": "LinkedField",
            "name": "setPrimaryAccount",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "success",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedMutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedMutationErrorExtension",
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "errorType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusCode",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SetPrimaryAccountMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetPrimaryAccountMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "d84f505033da6f379b276fd62cbc65f6",
    "id": null,
    "metadata": {},
    "name": "SetPrimaryAccountMutation",
    "operationKind": "mutation",
    "text": "mutation SetPrimaryAccountMutation(\n  $aaid: String!\n) {\n  unified {\n    account {\n      setPrimaryAccount(aaid: $aaid) {\n        message\n        success\n        errors {\n          message\n          code\n          extensions {\n            errorType\n            statusCode\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8c78998f026f1064403dafc866f65cef";

export default node;
